module.exports = __webpack_public_path__ + "static/media/company-logo-placeholder.5281cd45.png";